import React, { Suspense, useEffect, useState, lazy } from 'react'
// eslint-disable-next-line
import { Route, Switch, Redirect, useLocation, useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'

import EditTemplate from '../components/Pages/Template/EditTemplate.jsx'
import CreateTemplate from '../components/Pages/Template/CreateTemplate.jsx'
import CreateJob from '../components/Pages/Job/CreateJob.jsx'
import ControlsDemo from '../components/Pages/ControlsDemo.jsx'
import FormDemo from '../components/Pages/FormDemo.jsx'
import FormDemoEdit from '../components/Pages/FormDemoEdit.jsx'
import PopperDemo from '../components/Pages/PopperDemo.jsx'
import { LandingPage } from '../components/Pages/DashBoard/LandingPage'
import * as routePaths from './routePaths'
import AssignJob from '../components/Pages/Job/JobAssignment.jsx'
import UploadCustomerData from '../components/Pages/Job/UploadCustomerData'
import EditJob from '../components/Pages/Job/EditJob.jsx'
import DataEntry from '../components/Pages/DataEntry/DataEntry.jsx'
// import QualityCheck from '../components/Pages/QualityCheck/JobsForQualityCheck.jsx'
import FilesForQualityCheck from '../components/Pages/QualityCheck/FilesForQualityCheck.jsx'
import BoxFlowForQualityCheck from '../components/Pages/QualityCheck/BoxFlowForQualityCheck.jsx'
import BoxesForQualityCheck from '../components/Pages/QualityCheck/BoxesForQualityCheck.jsx'
import QualityHubJobs from '../components/Pages/QualityCheck/QualityHubJobs.jsx'
import DataEntryViewAllFiles from '../components/Pages/DataEntry/ViewAllFiles'
import BoxList from '../components/Pages/Job/BoxList'
import ActivitySubList from '../components/Pages/SmartCatalog/ActivitySubList.jsx'
import ActivityAddImages from '../components/Pages/SmartCatalog/ActivityAddImages.jsx'
// import ActivityAddImagesScanbot from '../components/Pages/SmartCatalog/ActivityAddImagesScanbot.jsx'

import { getSidebarRouteLandingPage } from './sidebarRoutes'
import { isLoggedIn, getUserRole, indexOfviewAllJobs, indexOfCreateJob, indexOfQualityCheck, indexOfViewProductivityReport, indexOfSearchTemplate, indexOfEditJob, indexOfCreateTemplate, indexOfLocalAI, indexOfConfiguration } from '../redux/global'
import { userRoleAdmin, userRoleSuperUser, userRoleSupervisor, userRoleUser } from '../common/constants'
// import AllJobs from '../components/Pages/Job/AllJobs/AllJobs.jsx'
import AllOpenJobs from '../components/Pages/Job/AllOpenJobs/AllOpenJobs.jsx'
import ClosedJobs from '../components/Pages/Job/ClosedJobs/ClosedJobs.jsx'
// import MyJobs from '../components/Pages/Job/MyJobs/MyJobs.jsx'
import MyJobsNew from '../components/Pages/Job/MyJobsNew/MyJobsNew.jsx'
import CreateActivity from '../components/Pages/SmartCatalog/CreateActivity.jsx'
import AddActivity from '../components/Pages/SmartCatalog/AddActivity.jsx'
import ViewActivity from '../components/Pages/SmartCatalog/ViewActivity.jsx'
import ViewTemplate from '../components/Pages/SmartCatalog/ViewTemplate.jsx'
import TemplateSearch from '../components/Pages/Template/TemplateSearch/TemplateSearch.jsx'
import TemplateSearchTable from '../components/Pages/Template/TemplateSearch/templateSearchTable.jsx'
import EmployeeLevel from '../components/Pages/Reports/EmployeeLevel.jsx'
import CustomerLevel from '../components/Pages/Reports/CustomerLevel.jsx'
import AllJobsExceptionBoxes from '../components/Pages/Job/ExceptionBoxes/AllJobsExceptionBoxes.jsx'
import ModifyTemplate from '../components/Pages/SmartCatalog/ModifyTemplate.jsx'
import ErrorPage from '../components/Pages/ErrorPage.jsx'
import ManageLockedFields from '../components/Pages/SmartCatalog/ManageLockedField.jsx'
// import { SmartCatalogLandingPage } from '../components/Pages/SmartCatalog/SmartCatalogDashboard.jsx'
import { ImageExceptionDetails } from '../components/Pages/SmartCatalog/ImageExceptionDetails.jsx'
import ViewBoxTransmittals from '../components/Pages/SmartCatalog/ViewBoxTransmittals.jsx'
import AddBoxTransmittals from '../components/Pages/SmartCatalog/AddBoxTransmittals.jsx'
import BatchTransmittalDetails from '../components/Pages/SmartCatalog/BatchTransmittalDetails.jsx'
import BoxImageDetails from '../components/Pages/SmartCatalog/BoxImageDetails.jsx'
import NewDashboard from '../components/Pages/SmartCatalog/NewDashboard.jsx'
import BoxTransmittalExceptionDetails from '../components/Pages/SmartCatalog/BoxTransmittalExceptionDetails.jsx'
import ManageCustomerExclusions from '../components/Pages/SmartCatalog/ManageCustomerExclusions.jsx'
import EdgeCountrySettings from '../components/Pages/Configuration/EdgeCountrySettings.jsx'
import EdgeDeviceManagement from '../components/Pages/Configuration/EdgeDeviceManagement.jsx'
import EdgeAIRouter from './EdgeAIRouter'

const ViewAllFilesForQualityCheck = lazy(() =>
  import('../components/Pages/QualityCheck/ViewAllFilesForQualityCheck.jsx')
)

export const ProtectedRoute = props => {
  const location = useLocation()
  const userRole = getUserRole()
  const allowedTo = props.allowedTo === undefined ? true : Array.isArray(props.allowedTo) ? props.allowedTo.some(e => e === userRole) : props.allowedTo === userRole

  return (isLoggedIn()
    ? (allowedTo ? <Route {...props} /> : <Redirect to={routePaths.root} />)
    : <Redirect
        to={{
          pathname: routePaths.root,
          state: { from: location }
        }}
    />
  )
}

ProtectedRoute.propTypes = {
  allowedTo: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string
  ]),
}
const AdditionalPermissionGuard = ({ isAllowed, redirectTo, children }) => {
  const location = useLocation()

  if (!isLoggedIn()) {
    return (
      <Redirect to={{ pathname: routePaths.root, state: { from: location } }} />
    )
  }
  // don't remove this condition it is specifically for handle problem with use effect setting permision
  if (isAllowed === null) {
    return null
  }

  if (!isAllowed) {
    return <Redirect to={redirectTo || routePaths.userDashboard} />
  }

  return <>{children}</>
}

AdditionalPermissionGuard.propTypes = {
  isAllowed: PropTypes.bool,
  redirectTo: PropTypes.string,
}

const TodoComponent = () => {
  return (
    <div>To Be Completed</div>
  )
}

const AllJobs = () => {
  const history = useHistory()
  history.push(`${routePaths.AllOpenJobs}`)
  return null
}

export default () => {
  const [allowCreateJob, setAllowCreateJob] = useState('')
  // const [allowAssignJob, setAllowAssignJob] = useState('')
  const [allowQualityCheck, setAllowQualityCheck] = useState('')
  const [allowTemplateSearch, setAllowTemplateSearch] = useState('')
  const [allowViewAllJobs, setAllowViewAllJobs] = useState('')
  const [allowViewingReports, setAllowViewingReports] = useState('')

  //  for supervisor
  const [allowEditJob, setAllowEditJob] = useState('')
  const [allowCreateTemplate, setAllowCreateTemplate] = useState('')

  // for Edge AI and Configuration 
  const [hasLocalAiPermission, setHasLocalAiPermission] = useState(null)
  const [hasConfigurationPermission, SetHasConfigurationPermission] = useState(null)
  // implementation for nats provider wrapper — replaced by EdgeAIRouter base route
  // const location = useLocation() 

  const handleAdditionalPermissions = () => {
    let localAiEnabled = false
    let configurationEnabled = false
    const additionalGivenPermissions = window.sessionStorage.getItem('additional-permissions-user')
    if (additionalGivenPermissions !== 'undefined' && additionalGivenPermissions !== undefined && userRoleUser) {
      const additionalPermissionsForUser = JSON.parse(additionalGivenPermissions)
      if (additionalPermissionsForUser[indexOfCreateJob]?.enabled) {
        setAllowCreateJob(userRoleUser)
      }
      // if (additionalPermissionsForUser[indexOfAssignJob]?.enabled) {
      //   setAllowAssignJob(userRoleUser)
      // }
      if (additionalPermissionsForUser[indexOfviewAllJobs]?.enabled) {
        setAllowViewAllJobs(userRoleUser)
      }
      if (additionalPermissionsForUser[indexOfQualityCheck]?.enabled) {
        setAllowQualityCheck(userRoleUser)
      }
      if (additionalPermissionsForUser[indexOfSearchTemplate]?.enabled) {
        setAllowTemplateSearch(userRoleUser)
      }
      if (additionalPermissionsForUser[indexOfViewProductivityReport]?.enabled) {
        setAllowViewingReports(userRoleUser)
      }
      if (additionalPermissionsForUser[indexOfLocalAI]?.enabled) {
        localAiEnabled = true
      }
      if (additionalPermissionsForUser[indexOfConfiguration]?.enabled) {
        configurationEnabled = true
      }
    }

    // for supervisor
    if (additionalGivenPermissions !== 'undefined' && additionalGivenPermissions !== undefined && userRoleSupervisor) {
      const additionalPermissionsForUser = JSON.parse(additionalGivenPermissions)
      if (additionalPermissionsForUser[indexOfEditJob]?.enabled) {
        setAllowEditJob(userRoleSupervisor)
      }
      if (additionalPermissionsForUser[indexOfCreateTemplate]?.enabled) {
        setAllowCreateTemplate(userRoleSupervisor)
      }
    }
    setHasLocalAiPermission(localAiEnabled)
    SetHasConfigurationPermission(configurationEnabled)
  }
  useEffect(() => {
    handleAdditionalPermissions()
  }, [])

  return (
    <Suspense fallback={null}>
    <Switch>
      <ProtectedRoute exact path={routePaths.root} component={() => <Redirect to={getSidebarRouteLandingPage()} />} />
      <ProtectedRoute path={routePaths.controlsDemo} component={ControlsDemo} />
      <ProtectedRoute path={routePaths.todoComponent} component={TodoComponent} />
      <ProtectedRoute path={routePaths.formDemo} component={FormDemo} />
      <ProtectedRoute path={routePaths.formDemoEdit} component={FormDemoEdit} />
      <ProtectedRoute path={routePaths.popperDemo} component={PopperDemo} />
      <ProtectedRoute allowedTo={[userRoleSuperUser]} path={routePaths.superUserDashboard} component={LandingPage} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser]} path={routePaths.adminDashboard} component={LandingPage} />
      <ProtectedRoute path={routePaths.SmartCatalogDashboard} component={NewDashboard} />
      <ProtectedRoute path={routePaths.viewBoxTransmittals} component={ViewBoxTransmittals} />
      <ProtectedRoute path={routePaths.addBoxTransmittals} component={AddBoxTransmittals} />
      <ProtectedRoute path={routePaths.uploadBoxTransmittals} component={AddBoxTransmittals} />
      <ProtectedRoute path={routePaths.batchTransmittals}component={BatchTransmittalDetails} />
      <Route path={`${routePaths.ImageExceptionDetails}/:label`} component={ImageExceptionDetails} />
      <ProtectedRoute path={routePaths.boxTransmittalExceptionDetails} component={BoxTransmittalExceptionDetails} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, userRoleSupervisor]} path={routePaths.supervisorDashboard} component={LandingPage} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, userRoleSupervisor, allowViewingReports]} path={routePaths.employeeReports} component={EmployeeLevel} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, userRoleSupervisor, allowViewingReports]} path={routePaths.customerReports} component={CustomerLevel} />
      <ProtectedRoute path={routePaths.userDashboard} component={LandingPage} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, allowCreateTemplate]} path={routePaths.createTemplate} component={CreateTemplate} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser]} path={routePaths.editTemplate} component={EditTemplate} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, userRoleSupervisor, allowCreateJob]} path={routePaths.createJob} component={CreateJob} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, userRoleSupervisor, userRoleUser]} path={routePaths.assignJob} component={AssignJob} />
      <ProtectedRoute path={routePaths.dataEntry} component={DataEntry} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, userRoleSupervisor]} path={routePaths.UploadCustomerData} component={UploadCustomerData} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, allowEditJob]} path={routePaths.editJob} component={EditJob} />
      {/* <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, userRoleSupervisor, allowQualityCheck]} path={routePaths.qualityCheck} component={QualityCheck} /> */}
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, userRoleSupervisor, allowQualityCheck]} path={routePaths.qualityCheck} component={QualityHubJobs} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, userRoleSupervisor, allowQualityCheck]} path={routePaths.fileQualityCheck} component={FilesForQualityCheck} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, userRoleSupervisor, allowQualityCheck]} path={routePaths.viewAllFileQualityCheck} component={ViewAllFilesForQualityCheck} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, userRoleSupervisor, allowQualityCheck]} path={routePaths.boxFlowQualityCheck} component={BoxFlowForQualityCheck} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, userRoleSupervisor, allowQualityCheck]} path={routePaths.boxQualityCheck} component={BoxesForQualityCheck} />
      <ProtectedRoute path={routePaths.dataEntryViewAllFile} component={DataEntryViewAllFiles} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, userRoleSupervisor, allowViewAllJobs]} path={routePaths.AllJobs} component={AllJobs} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, userRoleSupervisor, allowViewAllJobs]} path={routePaths.AllOpenJobs} component={AllOpenJobs} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, userRoleSupervisor, allowViewAllJobs]} path={routePaths.ClosedJobs} component={ClosedJobs} />
      {/* <ProtectedRoute path={routePaths.myJobs} component={MyJobs} /> */}
      <ProtectedRoute path={routePaths.myJobs} component={MyJobsNew} />
      <ProtectedRoute path={routePaths.createActivity} component={CreateActivity} />
      <ProtectedRoute path={routePaths.addActivity} component={AddActivity} />
      <ProtectedRoute path={routePaths.viewActivity} component={ViewActivity} />
      <ProtectedRoute allowedTo={[userRoleSuperUser]} path={routePaths.viewTemplate} component={ViewTemplate} />
      <ProtectedRoute allowedTo={[userRoleSuperUser]} path={routePaths.ManageLockedFields} component={ManageLockedFields} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, userRoleSupervisor, allowTemplateSearch]} path={routePaths.templateSearch} component={TemplateSearch} />
      <ProtectedRoute allowedTo={[userRoleAdmin, userRoleSuperUser, userRoleSupervisor, allowTemplateSearch]} path={routePaths.TemplateSearchTable} component={TemplateSearchTable} />
      <ProtectedRoute path={routePaths.boxList} component={BoxList} />
      <ProtectedRoute path={routePaths.activityList} component={ActivitySubList} />
      <ProtectedRoute path={routePaths.activityAddImages} component={ActivityAddImages} />
      {/* <ProtectedRoute path={routePaths.activityAddImages} component={ActivityAddImagesScanbot} /> */}
      <ProtectedRoute path={routePaths.AllJobsExceptionBoxes} component={AllJobsExceptionBoxes} />
      <ProtectedRoute path={routePaths.ModifyTemplate} component={ModifyTemplate} />
      <ProtectedRoute path={routePaths.boxImageDetails} component={BoxImageDetails} />
      <ProtectedRoute path={routePaths.manageCustomerExclusions} component={ManageCustomerExclusions} />
      {/* edge ai routes — now handled by EdgeAIRouter */}
      <Route path={routePaths.edgeAIBase} render={(routeProps) => (
        <AdditionalPermissionGuard
          isAllowed={hasLocalAiPermission}
          redirectTo={routePaths.userDashboard}
        >
          <EdgeAIRouter {...routeProps} />
        </AdditionalPermissionGuard>
      )} />

    <ProtectedRoute path={routePaths.edgeCountrySettings} allowedTo={[userRoleSuperUser]} render={(routeProps) => (
        <AdditionalPermissionGuard
          isAllowed={hasConfigurationPermission}
          redirectTo={routePaths.userDashboard}
        >
          <EdgeCountrySettings {...routeProps} />
        </AdditionalPermissionGuard>
    )} />

    <ProtectedRoute path={routePaths.edgeDeviceManagement} allowedTo={[userRoleSuperUser]} render={(routeProps) => (
        <AdditionalPermissionGuard
          isAllowed={hasConfigurationPermission}
          redirectTo={routePaths.userDashboard}
        >
          <EdgeDeviceManagement {...routeProps} />
        </AdditionalPermissionGuard>
    )} />
      
      <ProtectedRoute component={ErrorPage} />
    </Switch>
    </Suspense>
  )
}

